import { UntypedFormGroup } from '@angular/forms';

export const passwordFormat = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?:(?:(\d){0,3}(?!\1))?(?:([a-z]){0,3}(?!\2))?(?:([A-Z]){0,3}(?!\3))?)*$/;


export function matchValidator(...compareFields: string[]) {
  return (formGroup: UntypedFormGroup) => {
    const sameValues = compareFields
      .map((field) => formGroup.get(field).value as string)
      .every((value, index, self) => self[0] === value);

    return sameValues ? null : { mismatch: true };
  };
}
